/**
 * T-shirt sizes available for redshirts
 */
export const TSHIRT_SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'] as const

export type TshirtSize = (typeof TSHIRT_SIZES)[number]

/**
 * T-shirt size options for dropdowns/selects
 */
export const TSHIRT_SIZE_OPTIONS = TSHIRT_SIZES.map(size => ({
  value: size,
  label: size,
}))
